import mergeWithDefaults from './mergeWithDefaults';

/**
 * Apply per‑key default templates to an object.
 *
 * * For each entry in `defaultTemplates`:
 *   * If `sourceObject` already has that key → **deep‑merge** the template with
 *     the existing value using {@link mergeWithDefaults}. Existing primitives/
 *     arrays always win over the template (they’re *overrides*).
 *   * If the key is missing → insert the template verbatim.
 *
 * Neither argument is mutated.
 *
 * @param {Object} [sourceObject={}]     original object (may be `null`)
 * @param {Object} [defaultTemplates={}] map of default templates
 * @returns {Object} cloned result with defaults applied
 */
const applyNestedDefaults = (sourceObject = {}, defaultTemplates = {}) => {
  const src = sourceObject ?? {}; // tolerate null
  const templates = defaultTemplates ?? {};

  const result = { ...src }; // shallow clone

  Object.entries(templates).forEach(([key, template]) => {
    result[key] = mergeWithDefaults(template, src[key]);
  });

  return result;
};

export default applyNestedDefaults;
